'use strict'

//
// All component javascript libraries should be included here as the
// demo component has been included for example.
// As the demo component is just included for demonstration purposes it should
// be removed at some point.
//
const { ScrollTopButton } = require("../components/01-elements/scroll-top-button/scroll-top-button")
const { AnchorLinks } = require("../components/01-elements/anchor-links/anchor-links")
const { NewsLoadMore } = require("../components/01-elements/news-load-more/news-load-more")
const { TextExpand } = require("../components/02-components/text-expand/text-expand")
const { Video } = require("../components/01-elements/video/video")
import initializeSlider from '../components/02-components/slider/slider'
import initializeAnchorNavigation from '../components/02-components/anchor-navigation/anchor-navigation'
import initializeHeroNav from '../components/02-components/hero/hero-navigation'
import initializeHeader from '../components/02-components/header/header'
import initializeHeaderFlyout from '../components/02-components/header-flyout/header-flyout'
import initializeLanguageFlyout from '../components/02-components/language-flyout/language-flyout'
import initializeTabNavigation from '../components/02-components/tab-navigation/tab-navigation'
import initializeGalleryModal from '../components/02-components/gallery/gallery'
import initializeModal from '../components/02-components/modal/modal'
import initializeMapview from '../components/02-components/mapview/mapview'
import initializeInquery from '../components/02-components/inquery/inquery'
import initializeVtsHeader from '../components/03-vts/header/header'
import initializeTeaserCards from '../components/02-components/teaser-card/teaser-cards'
import initializeTeaserSlider from '../components/02-components/teaser/teaser-slider'
import initializeTextMediaSlider from '../components/02-components/text-media/text-media-slider'
import initializeHeroSlider from '../components/02-components/hero/hero-slider'

//
// Below is the main jQuery function that gets called as soon as the DOM is
// ready. Yes, the use of jQuery is allowed and you are encouraged to use it.
// The main function call below is analog to the now deprecated
// $(document).ready() function call used in earlier jQuery versions.
// Please also remove the Demo method calls at some point as they are only
// mentioned here for demonstration purposes.
//
jQuery(function ($) {
  ScrollTopButton.init()
  AnchorLinks.init()
  NewsLoadMore.init()
  TextExpand.init()
  Video.init()
  initializeSlider()
  initializeAnchorNavigation()
  initializeHeroNav()
  initializeHeader()
  initializeHeaderFlyout()
  initializeLanguageFlyout()
  initializeTabNavigation()
  initializeGalleryModal()
  initializeModal()
  initializeMapview()
  initializeInquery()
  initializeVtsHeader()
  initializeTeaserCards()
  initializeTeaserSlider()
  initializeTextMediaSlider()
  initializeHeroSlider()
})

